import type { LangId } from "./types";

export const PLAINTEXT: LangId = "plaintext";

const BUILTINS: ReadonlyArray<readonly [string, LangId]> = [
  [".ts", "typescript"],
  [".tsx", "tsx"],
  [".js", "javascript"],
  [".jsx", "jsx"],
  [".mjs", "javascript"],
  [".cjs", "javascript"],
  [".json", "json"],
  [".jsonc", "jsonc"],
  [".md", "markdown"],
  [".markdown", "markdown"],
  [".py", "python"],
  [".rs", "rust"],
  [".go", "go"],
  [".html", "html"],
  [".htm", "html"],
  [".xml", "xml"],
  [".svg", "xml"],
  [".css", "css"],
  [".scss", "scss"],
  [".less", "less"],
  [".yaml", "yaml"],
  [".yml", "yaml"],
  [".sh", "shellscript"],
  [".bash", "shellscript"],
  [".zsh", "shellscript"],
  [".sql", "sql"],
  [".toml", "toml"],
  [".c", "c"],
  [".h", "c"],
  [".cpp", "cpp"],
  [".cc", "cpp"],
  [".hpp", "cpp"],
  [".java", "java"],
  [".kt", "kotlin"],
  [".swift", "swift"],
  [".rb", "ruby"],
  [".php", "php"],
  [".lua", "lua"],
  [".dart", "dart"],
  [".vue", "vue"],
];

export const EXT_TO_LANG: Map<string, LangId> = new Map(BUILTINS);

/**
 * Register a user-defined language → extension mapping. Overrides builtin
 * extensions if there's a collision (yaml DSL wins, by spec design).
 */
export function registerLang(langId: LangId, extensions: ReadonlyArray<string>): void {
  for (const ext of extensions) {
    const norm = ext.toLowerCase();
    if (!norm.startsWith(".")) continue;
    EXT_TO_LANG.set(norm, langId);
  }
}

export function detectLang(filename: string | undefined): LangId {
  if (!filename) return PLAINTEXT;
  const base = filename.split(/[\\/]/).pop() ?? filename;
  const dot = base.lastIndexOf(".");
  if (dot <= 0) return PLAINTEXT;  // no ext, or pure dotfile like ".gitignore"
  const ext = base.slice(dot).toLowerCase();
  return EXT_TO_LANG.get(ext) ?? PLAINTEXT;
}
